export default "__VITE_ASSET__Bc0F$Nq$__"